module.exports = __webpack_public_path__ + "6bd69568d5d3c0713d6904f49b9c718a.svg";